import { useSelector } from 'react-redux';
import { useNavigate, useParams, Outlet } from 'react-router-dom';
import { RootState } from '../../types/graph';
import { usePatients } from '../../hooks/patient.hooks';

export const InvitationRoutes = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const invitationId = useSelector((state: RootState) => state.invitationId);
  usePatients({
    onSuccess: (patients) => {
      if (patients?.length && invitationId === id) {
        navigate('/patient/select');
      }
    },
  });

  return <Outlet />;
};
